/* eslint-disable no-unused-vars */
import httpService from '@/services/httpService'
import { types as rootTypes } from '../../index'
import helper from '@/services/Helper'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import _ from 'lodash'
import AdvancedOptions from '../../../features/reports/common/advanced-options/AdvancedOptions'
import Status from '../../../features/reports/rank-zone/status/Status'
import Sections from '../../../features/reports/rank-zone/sections/Sections'
import Url from '../../../features/reports/rank-zone/url/Url'
import UrlPopup from '../../../features/reports/common/UrlPopup'

// default page types
const ALLOWED_PAGE_TYPES = [
  'Product',
  'Editorial',
  'Category',
  'Resource',
  'Homepage',
  'Other',
  'Location'
]

export const types = {
  SET_RANK_ZONE_SESSION_STATUS: 'rank-zone/SET_RANK_ZONE_SESSION_STATUS',
  RESET_RANK_ZONE_SESSION_STATUS: 'rank-zone/RESET_RANK_ZONE_SESSION_STATUS',
  ADD_URL_SNAPSHOT: 'rank-zone/ADD_URL_SNAPSHOT',
  ADD_RANK_ZONE_SNAPSHOTS: 'rank-zone/ADD_RANK_ZONE_SNAPSHOTS',
  ADD_MSV: 'rank-zone/ADD_MSV',
  ADD_WRITING_STATUSES: 'rank-zone/ADD_WRITING_STATUSES',
  ADD_RANK_ZONE_STATUSES: 'rank-zone/ADD_RANK_ZONE_STATUSES',
  ADD_RANK_ZONE_SECTIONS: 'rank-zone/ADD_RANK_ZONE_SECTIONS',
  ADD_RANK_ZONE_COMPANIES: 'rank-zone/ADD_RANK_ZONE_COMPANIES',
  ADD_RANK_ZONE_ATTRIBUTES: 'rank-zone/ADD_RANK_ZONE_ATTRIBUTES',
  ADD_RANK_ZONE_SCORES: 'rank-zone/ADD_RANK_ZONE_SCORES',
  ADD_RANK_ZONE_PAGE_TYPES: 'rank-zone/ADD_RANK_ZONE_PAGE_TYPES',
  ADD_RANK_ZONE_MISMATCHED_URLS: 'rank-zone/ADD_RANK_ZONE_MISMATCHED_URLS',
  ADD_RANK_ZONE_IS_OPTIMIZED: 'rank-zone/ADD_RANK_ZONE_IS_OPTIMIZED',
  ADD_RANK_ZONE_SERP_FEATURES: 'rank-zone/ADD_RANK_ZONE_SERP_FEATURES',
  ADD_RANK_ZONE_URL_ATTRIBUTES: 'rank-zone/ADD_RANK_ZONE_URL_ATTRIBUTES',
  ADD_RANK_ZONE_URL_STATUSES: 'rank-zone/ADD_RANK_ZONE_URL_STATUSES',
  ADD_RANK_ZONE_CONTENT_BRIEF_STATUSES: 'rank-zone/ADD_RANK_ZONE_CONTENT_BRIEF_STATUSES',
  ADD_RANK_ZONE_WEB_PROPERTY_GROUPS: 'rank-zone/ADD_RANK_ZONE_WEB_PROPERTY_GROUPS',
  ADD_RANK_ZONE_MAPPED_URLS: 'rank-zone/ADD_RANK_ZONE_MAPPED_URLS',
  ADD_RANK_ZONE_WEB_PROPERTIES: 'rank-zone/ADD_RANK_ZONE_WEB_PROPERTIES',
  ADD_RANK_ZONE_AUTOCOMPLETE: 'rank-zone/ADD_RANK_ZONE_AUTOCOMPLETE',
  ADD_RANK_ZONE_AUTOCOMPLETE_RESET: 'rank-zone/ADD_RANK_ZONE_AUTOCOMPLETE_RESET',
  ADD_RANK_ZONE_AUTOCOMPLETE_STATUS: 'rank-zone/ADD_RANK_ZONE_AUTOCOMPLETE_STATUS',
  ADD_RANK_ZONE_EXPANDED_ITEM: 'rank-zone/ADD_RANK_ZONE_EXPANDED_ITEM',
  ADD_RANK_ZONE_TRIAL_END_DATE: 'rank-zone/ADD_RANK_ZONE_TRIAL_END_DATE',
  ADD_RANK_ZONE_TRIAL_DAYS_LEFT: 'rank-zone/ADD_RANK_ZONE_TRIAL_DAYS_LEFT',
  ADD_DIFFICULTY_SCORE_ENABLED: 'rank-zone/ADD_DIFFICULTY_SCORE_ENABLED',
  ADD_PUBLISHING_ENABLED: 'rank-zone/ADD_PUBLISHING_ENABLED',
  ADD_REPORTING_LOOKBACK_MONTHS: 'rank-zone/ADD_REPORTING_LOOKBACK_MONTHS',
  ADD_CLIENT_CONTRIBUTORS: 'rank-zone/ADD_CLIENT_CONTRIBUTORS',
  ADD_CLOUDFLARE_ENABLED: 'rank-zone/ADD_CLOUDFLARE_ENABLED',
  ADD_LINK_BUILDING_REPORT_ENABLED: 'rank-zone/ADD_LINK_BUILDING_REPORT_ENABLED',
  ADD_WEBHOOK_ENDPOINT_ENABLED: 'rank-zone/ADD_WEBHOOK_ENDPOINT_ENABLED',
  ADD_API_KEY_ENABLED: 'rank-zone/ADD_API_KEY_ENABLED',
  ADD_SHOPIFY_ENABLED: 'rank-zone/ADD_SHOPIFY_ENABLED'
}
const state = {
  snapshots: [],
  statuses: [],
  sections: [],
  companies: [],
  attributes: [],
  pageTypes: [],
  scores: [],
  mismatchedUrls: [],
  trial: {},
  clientContributors: [],
  urlStatuses: [],
  contentBriefStatuses: [],
  snapshotsLoadingCount: 0,
  isSnapshotsLoaded: false,
  difficultyScoreEnabled: false,
  publishingEnabled: false,
  shopifyEnabled: false,
  webhookEndpointEnabled: false,
  apiKeyEnabled: false,
  cloudflareEnabled: false,
  linkBuildingReportEnabled: false,
  webPropertyGroups: [],
  mappedUrls: [],
  webProperties: [],
  writingStatuses: [],
  // number to handle several simultaneously requests status
  isAutocompleteDataUpdating: 0,
  autocomplete: {},
  urlSnapshotsData: {
    0: null,
    1: null
  },
  isOptimized: [],
  msv: [],
  serpFeature: [],
  urlAttributes: [],
  // we use it to address keyword loading request result to specific store
  KEYWORDS_PATH: {
    SECTION: 'rankZoneSection/setKeywords',
    STATUS: 'rankZoneStatus/setKeywords',
    URL: 'rankZoneUrl/setKeywords'
  },
  expandedItem: null
}

const mutations = {
  [types.SET_RANK_ZONE_SESSION_STATUS]: function (state) {
    state.snapshotsLoadingCount--
    state.isSnapshotsLoaded = state.snapshotsLoadingCount === 0
  },
  [types.RESET_RANK_ZONE_SESSION_STATUS]: function (state) {
    state.snapshotsLoadingCount++
    state.isSnapshotsLoaded = false
  },
  [types.ADD_URL_SNAPSHOT]: function (state, { data, index }) {
    state.urlSnapshotsData = { ...state.urlSnapshotsData, [index]: data }
  },
  [types.ADD_RANK_ZONE_SNAPSHOTS]: function (state, snapshots) {
    state.snapshots = helper.sortSnapshots(snapshots)
  },
  [types.ADD_RANK_ZONE_STATUSES]: function (state, statuses) {
    state.statuses = statuses || []
  },
  [types.ADD_RANK_ZONE_MAPPED_URLS]: function (state, mappedUrls) {
    state.mappedUrls = mappedUrls || []
  },
  [types.ADD_DIFFICULTY_SCORE_ENABLED]: function (state, difficultyScoreEnabled) {
    state.difficultyScoreEnabled = !!difficultyScoreEnabled || false
  },
  [types.ADD_PUBLISHING_ENABLED]: function (state, publishingEnabled) {
    state.publishingEnabled = !!publishingEnabled || false
  },
  [types.ADD_REPORTING_LOOKBACK_MONTHS]: function (state, reportingLookbackMonths) {
    state.reportingLookbackMonths = reportingLookbackMonths || null
  },
  [types.ADD_CLOUDFLARE_ENABLED]: function (state, cloudflareEnabled) {
    state.cloudflareEnabled = !!cloudflareEnabled || false
  },
  [types.ADD_LINK_BUILDING_REPORT_ENABLED]: function (state, linkBuildingReportEnabled) {
    state.linkBuildingReportEnabled = !!linkBuildingReportEnabled || false
  },
  [types.ADD_SHOPIFY_ENABLED]: function (state, shopifyEnabled) {
    state.shopifyEnabled = !!shopifyEnabled || false
  },
  [types.ADD_WEBHOOK_ENDPOINT_ENABLED]: function (state, webhookEndpointEnabled) {
    state.webhookEndpointEnabled = !!webhookEndpointEnabled || false
  },
  [types.ADD_API_KEY_ENABLED]: function (state, apiKeyEnabled) {
    state.apiKeyEnabled = !!apiKeyEnabled || false
  },
  [types.ADD_RANK_ZONE_MISMATCHED_URLS]: function (state, mismatchedUrls) {
    state.mismatchedUrls = mismatchedUrls || []
  },
  [types.ADD_RANK_ZONE_SECTIONS]: function (state, sections) {
    state.sections = sections || []
  },
  [types.ADD_RANK_ZONE_COMPANIES]: function (state, companies) {
    state.companies = companies || []
  },
  [types.ADD_RANK_ZONE_ATTRIBUTES]: function (state, attributes) {
    state.attributes = attributes || []
  },
  [types.ADD_RANK_ZONE_SCORES]: function (state, scores) {
    state.scores = scores || []
  },
  [types.ADD_RANK_ZONE_URL_STATUSES]: function (state, urlStatuses) {
    state.urlStatuses = urlStatuses || []
  },
  [types.ADD_MSV]: function (state, msv) {
    state.msv = msv || []
  },
  [types.ADD_RANK_ZONE_CONTENT_BRIEF_STATUSES]: function (state, contentBriefStatuses) {
    state.contentBriefStatuses = contentBriefStatuses || []
  },
  [types.ADD_RANK_ZONE_PAGE_TYPES]: function (state, pageTypes) {
    state.pageTypes = pageTypes || []
  },
  [types.ADD_RANK_ZONE_WEB_PROPERTY_GROUPS]: function (state, groups) {
    state.webPropertyGroups = groups || []
  },
  [types.ADD_RANK_ZONE_WEB_PROPERTIES]: function (state, groups) {
    state.webProperties = groups || []
  },
  [types.ADD_RANK_ZONE_IS_OPTIMIZED]: function (state, groups) {
    state.isOptimized = groups || []
  },
  [types.ADD_RANK_ZONE_SERP_FEATURES]: function (state, groups) {
    state.serpFeature = groups || []
  },
  [types.ADD_RANK_ZONE_URL_ATTRIBUTES]: function (state, groups) {
    state.urlAttributes = groups || []
  },
  [types.ADD_RANK_ZONE_TRIAL_END_DATE]: function (state, trialEndDate) {
    state.trial = { ...state.trial, trialEndDate }
  },
  [types.ADD_RANK_ZONE_TRIAL_DAYS_LEFT]: function (state, trialDaysLeft) {
    state.trial = { ...state.trial, trialDaysLeft }
  },
  [types.ADD_WRITING_STATUSES]: function (state, writingStatuses) {
    state.writingStatuses = writingStatuses || []
  },
  /**
   *
   * @param list of values
   * @param start  string entered by user
   * @param id of row in Advanced Options list
   * @example:
   * state.autocomplete = {
   *     1575284787083: {
   *         list: [
   *              "https://www.sunglassunderground.com/lenses/"
   *              "https://www.sunglassunderground.com/brand/dior/"
   *              "https://www.sunglassunderground.com/brand/nike/"
   *         ],
   *         start: 'sunglass'
   *     }
   * }
   */
  [types.ADD_RANK_ZONE_AUTOCOMPLETE]: function (state, { list, start, id }) {
    const value = {
      list: list || [],
      start
    }
    state.autocomplete = { ...state.autocomplete, [id]: value }
  },
  [types.ADD_RANK_ZONE_AUTOCOMPLETE_RESET]: function (state) {
    state.autocomplete = {}
  },
  [types.ADD_RANK_ZONE_AUTOCOMPLETE_STATUS]: function (state, status) {
    state.isAutocompleteDataUpdating += status
  },
  [types.ADD_RANK_ZONE_EXPANDED_ITEM]: function (state, item) {
    state.expandedItem = item
  },
  [types.ADD_CLIENT_CONTRIBUTORS]: function (state, contributors) {
    state.clientContributors = contributors || []
  }
}

const actions = {
  /**
   * get client specific data
   */
  getSession: async function ({ commit, dispatch }, { clientId }) {
    commit(types.RESET_RANK_ZONE_SESSION_STATUS)
    const response = await httpService.get(`/reports/rankzone-report/get-session-data/${clientId}`)
    if (!response || !response.data) {
      return
    }
    let webPropertyGroups = response.data.web_property_groups
    if (webPropertyGroups) {
      webPropertyGroups.forEach(item => (item.order = item.type === 'Clients' ? 1 : item.type === 'Siblings' ? 2 : 3))
      webPropertyGroups = _.sortBy(webPropertyGroups, ['order', 'label'])
    }
    commit(types.ADD_RANK_ZONE_STATUSES, response.data.statuses)
    commit(types.ADD_RANK_ZONE_SECTIONS, response.data.sections)
    commit(types.ADD_RANK_ZONE_COMPANIES, webPropertyGroups)
    commit(types.ADD_RANK_ZONE_ATTRIBUTES, response.data.attributes)
    commit(types.ADD_WRITING_STATUSES, response.data.writing_statuses)
    commit(types.ADD_RANK_ZONE_IS_OPTIMIZED, response.data.is_optimized)
    commit(types.ADD_RANK_ZONE_URL_ATTRIBUTES, response.data.url_attributes)
    commit(types.ADD_RANK_ZONE_SERP_FEATURES, response.data.serp_feature)
    commit(types.ADD_RANK_ZONE_PAGE_TYPES, response.data.page_types.sort((element, nextElement) => element.label === 'Editorial' ? -1 : nextElement.label === 'Editorial' ? 1 : 0))
    commit(types.ADD_RANK_ZONE_URL_STATUSES, response.data.url_statuses)
    commit(types.ADD_RANK_ZONE_CONTENT_BRIEF_STATUSES, response.data.content_brief_statuses)
    commit(types.ADD_RANK_ZONE_WEB_PROPERTY_GROUPS, webPropertyGroups)
    commit(types.ADD_RANK_ZONE_WEB_PROPERTIES, response.data.web_properties)
    commit(types.ADD_RANK_ZONE_SCORES, response.data.scores)
    commit(types.ADD_RANK_ZONE_SNAPSHOTS, response.data.snapshots)
    commit(types.ADD_RANK_ZONE_MAPPED_URLS, response.data.mapped_urls)
    commit(types.ADD_RANK_ZONE_TRIAL_END_DATE, response.data.trial_end_date)
    commit(types.ADD_RANK_ZONE_TRIAL_DAYS_LEFT, response.data.trial_days_left)
    commit(types.ADD_MSV, response.data.msv)
    commit(types.ADD_DIFFICULTY_SCORE_ENABLED, response.data.difficulty_score_enabled)
    commit(types.ADD_PUBLISHING_ENABLED, response.data.publishing_enabled)
    commit(types.ADD_REPORTING_LOOKBACK_MONTHS, response.data.reporting_lookback_months)
    commit(types.ADD_SHOPIFY_ENABLED, response.data.shopify_enabled)
    commit(types.ADD_CLOUDFLARE_ENABLED, response.data.cloudflare_enabled)
    commit(types.ADD_LINK_BUILDING_REPORT_ENABLED, response.data.link_building_report_enabled)
    commit(types.ADD_API_KEY_ENABLED, response.data.api_key_enabled)
    commit(types.ADD_WEBHOOK_ENDPOINT_ENABLED, response.data.webhook_endpoint_enabled)
    commit(types.ADD_RANK_ZONE_MISMATCHED_URLS, response.data.mismatched_urls)
    commit(types.ADD_CLIENT_CONTRIBUTORS, response.data.contributors)
    commit(types.SET_RANK_ZONE_SESSION_STATUS)
    commit(rootTypes.ADD_UNHASHED_CLIENT_ID, response.data.client_id, { root: true })

    commit(rootTypes.ADD_ALLOWED_ROUTES, response.data.allowed_routes, { root: true })
    const sidebarRoutes = response.data.allowed_routes.map(route => {
      return {
        route: route,
        link: route
      }
    })
    commit(rootTypes.ADD_ADMIN_ROUTES, sidebarRoutes, { root: true })
    dispatch('getApplicationRoutes', null, { root: true })
    commit('agency/agency/ADD_BILLING_DATA', response.data.billing, { root: true })
  
    return response.data
  },
  /**
   * action for {@link UrlPopup} modal
   */
  getUrlSnapshotData: async function ({ commit }, { clientId, filters, indexes }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    filters.msv = msv[clientId] || 1
    indexes.forEach(index => commit(types.ADD_URL_SNAPSHOT, { data: null, index }))
    const params = convertAdvancedOptionsToURLParams(filters)
    try {
      const snapshotData = await httpService
        .get(`/reports/rankzone-report/compare-url-snapshots/${clientId}`, { params })
      snapshotData.data.forEach((snapshot, index) => {
        commit(types.ADD_URL_SNAPSHOT, { data: snapshot, index })
      })
    } catch (err) {
    }
  },
  /**
   *  action for autocomplete advanced options / Keywords, URL - exactly matching
   *  @param id - id of row in Advanced Options list
   *  @params filters - advanced options
   */
  async getAutocomplete ({ commit }, { clientId, filters, id }) {
    commit(types.ADD_RANK_ZONE_AUTOCOMPLETE_STATUS, 1)
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    filters.msv = msv[clientId] || 1
    let response = null
    response = await httpService.get(`/reports/rankzone-report/get-${filters.type}-autocomplete/${clientId}`, { params: { start: filters.start } })
    commit(types.ADD_RANK_ZONE_AUTOCOMPLETE_STATUS, -1)
    if (response.data) {
      commit(types.ADD_RANK_ZONE_AUTOCOMPLETE, { ...response.data, id })
    }
  },
  /**
   * @param id - id of row in Advanced Options list.
   * It's Date.now().valueOf() timestamp only for make rows distinct {@see AdvancedOptions#handlePredefinedFilters()}
   */
  async resetAutocompleteId ({ commit }, { id }) {
    commit(types.ADD_RANK_ZONE_AUTOCOMPLETE, { id })
  },
  async resetAutocomplete ({ commit }) {
    commit(types.ADD_RANK_ZONE_AUTOCOMPLETE_RESET)
  },

  /**
   * action for receiving keywords data for expanded url row
   * Used on screens {@link Status} {@link Sections} {@link Url}
   * @param filters - advanced options
   * @param screen - screen to address received keywords {@see state#KEYWORDS_PATH}
   * @returns {Promise<void>}
   */
  getKeywordsByUrlIdData: async function ({ commit, dispatch, rootState }, { clientId, filters, screen }) {
    let params = null
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    filters.msv = msv[clientId] || 1
    if (filters && filters.advancedFilters) {
      params = convertAdvancedOptionsToURLParams(filters)
    } else {
      params = filters
    }
    const response = await httpService.get(`/reports/rankzone-report/keyword/${clientId}`, { params: params }, { encode: false })
    if (!response || !response.data) {
      return
    }
    const keywords = _.get(response, 'data.keywords', [])
    commit(types.ADD_RANK_ZONE_EXPANDED_ITEM, null)
    dispatch(screen, { keywords, urlId: filters['url_id'] }, { root: true })
  },
  addExpandedItem ({ commit }, item) {
    commit(types.ADD_RANK_ZONE_EXPANDED_ITEM, item)
  },
  changeDiffScoreEnabled ({ commit }, value) {
    commit(types.ADD_DIFFICULTY_SCORE_ENABLED, value)
  },
  changePublishingEnabled ({ commit }, value) {
    commit(types.ADD_PUBLISHING_ENABLED, value)
  },
  changeReportingLookbackMonths ({ commit }, value) {
    commit(types.ADD_REPORTING_LOOKBACK_MONTHS, value)
  },
  changeCloudflareEnabled ({ commit }, value) {
    commit(types.ADD_CLOUDFLARE_ENABLED, value)
  },
  changeWebhookEndpointEnabled ({ commit }, value) {
    commit(types.ADD_WEBHOOK_ENDPOINT_ENABLED, value)
  },
  changeShopifyEnabled ({ commit }, value) {
    commit(types.ADD_SHOPIFY_ENABLED, value)
  },
  changeApiKeyEnabled ({ commit }, value) {
    commit(types.ADD_API_KEY_ENABLED, value)
  },
  changeLinkBuildingReportEnabled ({ commit }, value) {
    commit(types.ADD_LINK_BUILDING_REPORT_ENABLED, value)
  }
}

/**
 * Store receive common data
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
